const o = "_common_19x0h_1", n = "_button_19x0h_32", _ = "_link_19x0h_37", c = "_fake_19x0h_43", t = "_primary_19x0h_46", e = "_secondary_19x0h_53", a = "_label-wrapper_19x0h_60", i = "_label_19x0h_60", l = "_icon_19x0h_77", s = "_icon-left_19x0h_85", r = "_icon-right_19x0h_88", h = {
  common: o,
  button: n,
  link: _,
  fake: c,
  primary: t,
  secondary: e,
  labelWrapper: a,
  label: i,
  icon: l,
  iconLeft: s,
  iconRight: r
};
export {
  n as button,
  o as common,
  h as default,
  c as fake,
  l as icon,
  s as iconLeft,
  r as iconRight,
  i as label,
  a as labelWrapper,
  _ as link,
  t as primary,
  e as secondary
};
